import { InputSwitch } from 'primereact/inputswitch';
import React, { useState, useRef, useEffect } from 'react'
import { Controller, useForm } from 'react-hook-form';
import { NavLink, useNavigate, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import Overlay from '../../Components/Overlay/Overlay';
import { getRoleAll } from '../../Services/RoleService';
import { createUser, getModenaUserByEmail, getUserById, updateUser } from '../../Services/UserService';
import { pp_default } from '../../Images'
import { handlerFormError } from '../../Utils/Utils';
import { toastError } from '../../Components/Toasts/Toast';
import { useSelector } from 'react-redux';
import { updateImage } from "../../Store/Action/AuthAction";
import { useDispatch } from 'react-redux';

const { $ } = window;
let procesingId = -1;

const UserDetailPage = () => {
  const dispatch = useDispatch();
  const darkMode = useSelector(state => state.theme.darkMode);
  const { pageState, id } = useParams();
  const { userInfo } = useSelector(state => state.auth);
  const [state, setState] = useState({
    user: {
      role_id: -1
    },
    roles: [],
    processing: false,
    email: '',
    emails: [],
    selectedEmail: null,
    isFocus: false,
    withPassword: true
  });

  const { register, handleSubmit, watch, control, setValue, formState: { errors }, reset } = useForm({ defaultValues: { role_id: '', is_active: true } });
  const password = useRef({});
  password.current = watch("password", "");

  useEffect(() => {
    const requests = [getRoleAll({ perpage: 100 }).then(res => res.data.data)];

    switch (pageState) {
      case 'add':
        Promise.all(requests).then(results => {
          const [_roles] = results;
          setState({ ...state, roles: _roles, user: {} });
        });
        break;
      case 'edit':
      case 'profile':
        requests.push(
          getUserById(id)
            .then(res => res.data)
            .catch(({ response: { data: { message } } }) => {
              Swal.fire({
                icon: 'error',
                title: 'Error when getting user',
                text: message
              }).then(() => { navigate(-1) });
            })
        );
        Promise.all(requests).then(results => {
          const [_roles, _user] = results;
          _user.image = _user.image_name;
          setState({ ...state, roles: _roles, user: _user, withPassword: false, email: _user.email });
          reset(_user);
        });
        break;
      default:
        break;
    }

  }, []);

  const navigate = useNavigate();

  const onBack = () => { navigate(-1); }

  const onSelectImage = () => {
    $('#user-image').click();
  }

  const onuserImageChange = e => {
    const [file] = e.target.files;
    if (file) {
      const _user = { ...user, image: URL.createObjectURL(file), file };
      setState({ ...state, user: _user });
    }
  }

  const startProcessing = () => {
    procesingId = setTimeout(() => {
      setState({ ...state, processing: true });
    }, 150);
  }

  const stopProcessing = () => {
    clearInterval(procesingId);
    setState({ ...state, processing: false });
  }

  const onChangeEmail = (e) => {
    const isMailModena = e.target.value.includes('@modena.com');
    if (isMailModena) {
      setState({ ...state, withPassword: false, email: e.target.value, isFocus: true });
    } else {
      setState({ ...state, withPassword: true, email: e.target.value, isFocus: true });
    }
  }

  const onSubmit = (data) => {

    if (isFocus) {
      toastError("You are inputed modena's email, please click email from list!");
      return;
    }

    data.image = user.file;
    const formData = new FormData();
    for (var key in data) {
      formData.append(key, data[key]);
    }

    if (withPassword) {
      formData.delete("retypePassword");
      if (pageState.toLowerCase() == 'edit') {
        formData.delete("password");
      }
    }

    startProcessing();
    const response = pageState.toLowerCase() == 'add' ? createUser(formData) : updateUser(id, formData);
    response.then(async (res) => {
      if (res.status == 200 || res.status == 201) {
        if (user.file && userInfo.userid == id) {
          try {
            const userRes = await getUserById(id);
            if (userRes && userRes.data && userRes.data.image_name) {
              dispatch(updateImage(userRes.data.image_name));
            }
          } catch (e) {
            console.error("Failed to update user image:", e);
          }
        }

        Swal.fire({
          icon: 'success',
          title: 'Save data success',
          text: 'Data has been saved!'
        }).then(r => {
          onBack();
        })
      }
    }).catch(({ response: { data } }) => {
      handlerFormError(data);
    }).finally(_ => stopProcessing());
  }

  const { user, roles, processing, withPassword, email, emails, isFocus, selectedEmail } = state;

  useEffect(() => {
    if (email != '') {
      const time = setTimeout(() => {
        getModenaUserByEmail(email, ({ data }) => {
          if (data.total > 0) {
            setState({ ...state, emails: data.data });
          } else {
            setState({ ...state, isFocus: false });
          }
        });
      }, 150);

      return () => clearTimeout(time);
    } else {
      setState({ ...state, emails: [], isFocus: false });
    }

  }, [email]);

  const onSelectEmail = (item) => {
    setState({ ...state, selectedEmail: item, isFocus: false, withPassword: false });
    setValue('email', item.email);
    setValue('nik', item.emp_no);
    setValue('full_name', item.employe_name);
    setValue('phone', item.phone);
  };

  const onReset = () => {
    setState({ ...state, email: '', emails: [], selectedEmail: null, withPassword: true, isFocus: false })
    reset({
      email: '',
      nik: '',
      full_name: '',
      phone: ''
    });
  }

  return (
    <div className="content-wrapper">
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User</h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item"><NavLink to="/home">Home</NavLink></li>
                <li className="breadcrumb-item"><NavLink to="/user">User</NavLink></li>
                <li className="breadcrumb-item active">{pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className='col-md-12'>
              <div className='card'>
                <Overlay display={processing} />
                <form onSubmit={handleSubmit(onSubmit)}>
                  <div className='card-header'>
                    <div className='card-title'><i className='fa fa-user-tag' /> {pageState && pageState.charAt(0).toUpperCase() + pageState.slice(1)} User </div>
                  </div>
                  <div className='card-body'>
                    <div className='row mt-3 mb-3'>
                      <div className='col-md-12 d-flex flex-column align-items-center'>
                        <div className='mb-4' >
                          <img src={user.image || pp_default} alt='A' className='img-circle elevation-2' style={{ width: 160, height: 160 }} />
                        </div>
                        <div className='mb-3'>
                          {
                            pageState != 'profile' &&
                            <button type='button' className={`btn ${darkMode ? 'btn-outline-warning' : 'btn-outline-dark'}`} onClick={onSelectImage}>
                              <i className='fa fa-image' /> Select Image
                            </button>
                          }

                          <input id="user-image" type="file" accept="image/png, image/jpg, image/jpeg"
                            {...register("image")} className='d-none' onChange={onuserImageChange} />
                          {errors.image && <span className='text-danger d-block'>{errors.image.message}</span>}
                        </div>
                      </div>
                    </div>
                    <div className='row mb-4'>
                      <div className='col-md-12'>
                        <div className="dropdown-divider" />
                      </div>
                    </div>
                    <div className='row'>
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label htmlFor='email'>Email</label>
                          <input id="email" {...register("email", {
                            onChange: onChangeEmail,
                            email: { value: true, message: 'Invalid email!' },
                            required: 'Email is required!',
                          })} className='form-control' type="email" readOnly={selectedEmail || pageState == 'profile'} />

                          {errors.email && <span className='text-danger'>{errors.email.message}</span>}

                          {emails.length > 0 && isFocus && !selectedEmail &&
                            <div className='mt-1 p-2' style={{ zIndex: 1, position: 'absolute', background: darkMode ? "#777" : '#fff', border: '1px solid #ccc', borderRadius: 5, width: '97.2%' }}>
                              {
                                emails.map((item, i) =>
                                  <div onClick={() => onSelectEmail(item)} key={i} className='d-flex align-items-center w-100 p-1 mb-1' style={{ border: '1px solid #ccc', borderRadius: 5, cursor: 'pointer' }}>
                                    <span className='ml-2'>{item.email}</span>
                                  </div>
                                )
                              }
                            </div>
                          }
                        </div>

                        <div className='form-group'>
                          <label htmlFor='nik'>NIK</label>
                          <input id="nik" {...register("nik", { required: 'NIK is required!' })} className='form-control' readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                          {errors.nik && <span className='text-danger'>{errors.nik.message}</span>}
                        </div>
                        <div className='form-group'>
                          <label htmlFor='full_name'>Full Name</label>
                          <input id="full_name" {...register("full_name", { required: 'Fullname is required!' })} className='form-control' readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                          {errors.full_name && <span className='text-danger'>{errors.full_name.message}</span>}
                        </div>
                        <div className='form-group'>
                          <label htmlFor='phone'>Phone</label>
                          <input id="phone" {...register("phone")} className='form-control' type="text" readOnly={selectedEmail || (user && email && email.includes('modena.com')) || pageState == 'profile'} />
                        </div>
                        <div className='form-group'>
                          <label htmlFor='role_id'>Role</label>
                          <select id="role_id" className='form-control' {...register("role_id", { required: 'Role is required!' })} readOnly={pageState == 'profile'}>
                            <option value="" >Select Role</option>
                            {roles.map((item, i) => <option key={`item-role-${i}`} value={item._id}>{item.role_name}</option>)}
                          </select>
                          {errors.role_id && <span className='text-danger'>{errors.role_id.message}</span>}
                        </div>
                      </div>
                      <div className='col-md-1' />
                      <div className='col-md-4'>
                        <div className='form-group'>
                          <label htmlFor='username'>User Name</label>
                          <input id="username" {...register("username", { required: 'Username is required!' })} className='form-control' readOnly={pageState == 'profile'} />
                          {errors.username && <span className='text-danger'>{errors.username.message}</span>}
                        </div>

                        {withPassword && pageState.toLowerCase() != 'edit' && <> <div className='form-group'>
                          <label htmlFor='password'>Password</label>
                          <input id="password" {...register("password")} className='form-control' type="password" />
                          {errors.password && <span className='text-danger'>{errors.password.message}</span>}
                        </div>
                          <div className='form-group'>
                            <label htmlFor='retype-password'>Retype Password</label>
                            <input id="retype-password" {...register("retypePassword", { validate: val => password.current != '' && val == password.current || 'Password do not match' })} className='form-control' type="password" />
                            {errors.retypePassword && <span className='text-danger'>{errors.retypePassword.message}</span>}
                          </div></>}

                        <div className='form-group'>
                          <label htmlFor='active'>Active</label>
                          <div>
                            <Controller name="is_active" control={control} render={({ field }) => { return (<InputSwitch {...field} checked={field.value} disabled={pageState == 'profile'} />) }} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {
                    pageState != 'profile' &&
                    <div className='card-footer'>
                      <div className='row'>
                        <div className='col-md-12'>
                          <div className='d-flex' style={{ justifyContent: 'flex-end' }}>
                            <button type='button' className='btn btn-warning mr-3' style={{ width: 100 }} onClick={onBack}><i className='fa fa-reply' /> Back</button>
                            {
                              !user && <button type='button' className='btn btn-danger mr-3' style={{ width: 100 }} onClick={onReset}><i className='fa fa-times' /> Clear</button>
                            }
                            <button type='submit' className='btn btn-dark' style={{ width: 100 }}><i className='fa fa-save' /> Save</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </form>
              </div>
            </div>
          </div>
        </div >
      </section >
    </div >
  )
};

export default UserDetailPage;
